import { SensitiveWordsFileOutgoingRequestParams } from '../service'

type ChannelDef = { name: string; nameKey: string; value: string }

const data: { type: number; data: ChannelDef[] }[] = [
  {
    type: 1,
    data: [
      { name: 'HTTPS协议', nameKey: 'approvalTerminalFileOutsourcing.channelHttps', value: 'https' },
      { name: 'HTTP协议', nameKey: 'approvalTerminalFileOutsourcing.channelHttp', value: 'http' },
      { name: 'SMTP协议', nameKey: 'approvalTerminalFileOutsourcing.channelSmtp', value: 'smtp' },
      { name: 'SMTPS协议', nameKey: 'approvalTerminalFileOutsourcing.channelSmtps', value: 'smtps' },
      { name: 'FTP协议', nameKey: 'approvalTerminalFileOutsourcing.channelFtp', value: 'ftp' },
      { name: '共享目录', nameKey: 'approvalTerminalFileOutsourcing.channelShare', value: 'share' },
    ],
  },
  {
    type: 2,
    data: [
      { name: '微信', nameKey: 'approvalTerminalFileOutsourcing.channelWx', value: 'wx' },
      { name: '腾讯QQ', nameKey: 'approvalTerminalFileOutsourcing.channelQq', value: 'qq' },
      { name: '企业微信', nameKey: 'approvalTerminalFileOutsourcing.channelEnterpriseWx', value: 'enterprise_wx' },
      { name: '钉钉', nameKey: 'approvalTerminalFileOutsourcing.channelDingTalk', value: 'ding_talk' },
      { name: '飞书', nameKey: 'approvalTerminalFileOutsourcing.channelLark', value: 'lark' },
      { name: 'TIM', nameKey: 'approvalTerminalFileOutsourcing.channelTim', value: 'tim' },
    ],
  },
  {
    type: 3,
    data: [
      { name: '百度网盘', nameKey: 'approvalTerminalFileOutsourcing.channelBaiduNetdisk', value: 'baidu_netdisk' },
      { name: '夸克网盘', nameKey: 'approvalTerminalFileOutsourcing.channelQuark', value: 'quark' },
      { name: '腾讯微云', nameKey: 'approvalTerminalFileOutsourcing.channelWeiyun', value: 'weiyun' },
      { name: '阿里云盘', nameKey: 'approvalTerminalFileOutsourcing.channelAliyunDisk', value: 'aliyun_disk' },
      { name: '移动云盘', nameKey: 'approvalTerminalFileOutsourcing.channelMCloud', value: 'mCloud' },
    ],
  },
  {
    type: 4,
    data: [
      { name: '蓝牙', nameKey: 'approvalTerminalFileOutsourcing.channelBluetooth', value: 'bluetooth' },
      { name: '打印机', nameKey: 'approvalTerminalFileOutsourcing.channelPrinter', value: 'printer' },
      { name: '移动存储', nameKey: 'approvalTerminalFileOutsourcing.channelRemovableMedia', value: 'removablemedia' },
    ],
  },
]

const flatChannels = data.flatMap((g) => g.data)

/** value -> vue-i18n key（展示用）；接口仍可能回传中文 soft_name，见 approvalLabelToValue */
export const APPROVAL_CHANNEL_I18N_KEY = flatChannels.reduce<Record<string, string>>((acc, c) => {
  acc[c.value] = c.nameKey
  return acc
}, {})

export enum OperateState {
  Create = 1,
  Rename = 2,
  Copy = 3,
  Move = 4,
  Delete = 5,
  Zip = 6,
  RecycleBin = 7,
  RestoreFromRecycleBin = 8,
}
export type OperateStateKeys = keyof typeof OperateState
export type OperateStateValues = (typeof OperateState)[OperateStateKeys]

export const operateStateI18nKey: Partial<Record<OperateStateValues, string>> = {
  [OperateState.Create]: 'approvalTerminalFileOutsourcing.operateCreate',
  [OperateState.Rename]: 'approvalTerminalFileOutsourcing.operateRename',
  [OperateState.Copy]: 'approvalTerminalFileOutsourcing.operateCopy',
  [OperateState.Move]: 'approvalTerminalFileOutsourcing.operateMove',
  [OperateState.Delete]: 'approvalTerminalFileOutsourcing.operateDelete',
  [OperateState.Zip]: 'approvalTerminalFileOutsourcing.operateZip',
  [OperateState.RecycleBin]: 'approvalTerminalFileOutsourcing.operateRecycleBin',
  [OperateState.RestoreFromRecycleBin]: 'approvalTerminalFileOutsourcing.operateRestoreFromRecycleBin',
}

export const fileType = [
  'txt', 'ppt', 'rtf', 'pptx', 'docx', 'csv', 'jpg', 'jpeg', 'png', 'mp3', 'mp4', 'xlsx', 'xls', 'doc', 'log', 'pdf', 'mp4', 'bat', 'exe', 'wps', 'vue', 'react', 'zip', 'rar', 'html', 'css', 'js', 'ts', 'jsx', 'json', 'java', 'xml', '3ds', '7z', 'avi', 'bmp', 'dwg', 'fbx', 'glb', 'mov', 'gltf', 'fbx', 'pic', 'psd', 'raw', 'stl', 'tif', 'wav', 'wmv',
]

export enum ApplyState {
  Preview = 1,
  Allowed = 2,
  Rejected = 3,
  All = 0,
}
export type ApplyStateKeys = keyof typeof ApplyState
export type ApplyStateValues = Exclude<(typeof ApplyState)[ApplyStateKeys], ApplyState.Preview>

export const applyStateI18nKey: Partial<Record<ApplyStateValues, string>> = {
  [ApplyState.Allowed]: 'approvalTerminalFileOutsourcing.applyAgree',
  [ApplyState.Rejected]: 'approvalTerminalFileOutsourcing.applyReject',
  [ApplyState.All]: 'approvalTerminalFileOutsourcing.applyAll',
}

export const behaviorStateI18nKey: Record<1 | 2, string> = {
  1: 'approvalTerminalFileOutsourcing.behaviorHitSensitive',
  2: 'approvalTerminalFileOutsourcing.behaviorAllFiles',
}

export interface FormData {
  id: any
  behavior: keyof typeof behaviorStateI18nKey
  name: string
  group_ids: string[] | number[]
  bind_mode?: number
  device_ids?: string[]
  main_switch: 0 | 1
  keyword_actions: { keyword: string[]; action: 0 | 1 | 2 }[]
  send_channels_copy: { pipe: string[]; way: string; dictData: [] }[]
}
export type FormDataProps = keyof FormData
export type ApproveQueryForm = Partial<SensitiveWordsFileOutgoingRequestParams>
export type ExcludeRequestParamsApprove = Exclude<keyof SensitiveWordsFileOutgoingRequestParams, 'limit' | 'page'>
export const approvalType = flatChannels.map((item) => item.value)
/** 中文渠道名 -> value，兼容接口回传中文 soft_name */
export const approvalLabelToValue = flatChannels.reduce<Record<string, string>>((p, c) => {
  p[c.name] = c.value
  return p
}, {})

/** 将接口 soft_name（中文或 value）解析为通道 value，用于图标等 */
export function getApprovalChannelValue(softName: string): string | undefined {
  if (!softName) return undefined
  if (approvalType.includes(softName)) return softName
  return approvalLabelToValue[softName]
}

export function getApprovalChannelI18nKey(softName: string): string | undefined {
  const v = getApprovalChannelValue(softName)
  return v ? APPROVAL_CHANNEL_I18N_KEY[v] : undefined
}
